import React from "react";
// import styled from "styled-components";

const Loading = () => {
  return (
    <div className="section section-center">
      <div className="loading"></div>
    </div>
  );
};

export default Loading;
